const STORAGE_KEY = 'evidently_meds';

export function getMeds() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
}

export function isSaved(name) {
  return getMeds().some(m => m.name.toLowerCase() === name.toLowerCase());
}

export function saveMed(med) {
  const meds = getMeds().filter(m => m.name.toLowerCase() !== med.name.toLowerCase());
  meds.unshift({ ...med, savedAt: Date.now() });
  localStorage.setItem(STORAGE_KEY, JSON.stringify(meds.slice(0, 12)));
}

export function removeMed(name) {
  const meds = getMeds().filter(m => m.name.toLowerCase() !== name.toLowerCase());
  localStorage.setItem(STORAGE_KEY, JSON.stringify(meds));
}
